var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-card"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm._f("hhmmss")(_vm.t))+" hs")])])
}
var staticRenderFns = []

export { render, staticRenderFns }